// extracted by mini-css-extract-plugin
export default {"selector":"statusSelector_selector__i8A0G","targeted":"statusSelector_targeted__eUfSD"};